import state from './moduleUnidadeState'
import mutations from './moduleUnidadeMutations'
import actions from './moduleUnidadeActions'
import getters from './moduleUnidadeGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
